import { APP_PROFILE_REGISTER } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { IAppProfileRepository } from "features/appProfileRegister/domain/repositories/IAppProfileRepository";
import { injectable } from "tsyringe";
import { AppProfileRegisterListRequestModel } from "./model/AppProfileRegisterListRequestModel";
import { AppProfileModel } from "./model/AppProfileModel";
import { VerifyAppProfileRequestModel } from "./model/VerifyAppProfileRequestModel";

@injectable()
export class AppProfileRegisterRepositoryImpl implements IAppProfileRepository {
  async getProfileList(
    params: AppProfileRegisterListRequestModel,
  ): Promise<ListBaseApiResponseModel<AppProfileModel>> {
    return await client.get(APP_PROFILE_REGISTER.LIST, params);
  }

  async getProfileDetail(params: {
    id: string;
  }): Promise<BaseApiResponseModel<AppProfileModel>> {
    return await client.get(`${APP_PROFILE_REGISTER.DETAIL}${params?.id}`);
  }

  async verifyProfile(
    params: VerifyAppProfileRequestModel,
  ): Promise<BaseApiResponseModel<AppProfileModel>> {
    return await client.put(APP_PROFILE_REGISTER.VERIFY, params);
  }

  async syncStatus(params: {
    id: string;
  }): Promise<BaseApiResponseModel<AppProfileModel>> {
    return await client.put(`${APP_PROFILE_REGISTER.SYNC_STATUS}${params?.id}`);
  }

  async syncAllStatus(): Promise<BaseApiResponseModel<any>> {
    return await client.put(APP_PROFILE_REGISTER.SYNC_ALL_STATUS);
  }

  async exportExcel(params: AppProfileRegisterListRequestModel): Promise<Blob> {
    return await client.getBlob(APP_PROFILE_REGISTER.EXPORT_EXCEL, params);
  }

  async downLoadZip(id: string): Promise<Blob> {
    return await client.getBlob(`${APP_PROFILE_REGISTER.DOWNLOAD_ZIP}${id}`);
  }
}
